/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const transcriptData = data => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.transcriptCsv.url + '/' + data.payload.user_ID + '/' + data.payload.project_ID,
        maverickPortalApiEndPoint.transcriptCsv.methodType,
        data
      )
      .then(response => {
        const res = response.data;
        resolve({ res });
      });
  });
};

export { transcriptData };
